module.exports = __webpack_public_path__ + "static/media/rogue6_preview.3a39a7a0.jpg";